import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaUsers,
  FaTachometerAlt,
  FaClipboardList,
  FaFileInvoiceDollar,
  FaCashRegister,
  FaClock
} from "react-icons/fa";
import styled from "styled-components";

/* OVERLAY (todas telas agora) */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  z-index: 40;
  display: ${({ expanded }) => (expanded ? "block" : "none")};
`;

/* SIDEBAR */
const SidebarWrapper = styled.aside`
  width: 240px;
  background: #001f54;
  color: white;
  height: 100vh;
  position: fixed;
  top: 0;
  left: ${({ expanded }) => (expanded ? "0" : "-100%")};
  display: flex;
  flex-direction: column;
  transition: 0.3s ease;
  z-index: 50;
`;

/* MENU */
const MenuNav = styled.nav`
  margin-top: 70px;
  display: flex;
  flex-direction: column;
`;

/* ITEM */
const MenuItem = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 14px 22px;
  color: white;
  text-decoration: none;
  font-weight: 500;
  transition: 0.2s;

  &:hover {
    background: rgba(255,255,255,0.1);
  }

  &.active {
    background: #3b82f6;
    border-left: 4px solid yellow;
  }

  svg {
    font-size: 18px;
  }
`;

export default function Sidebar({ expanded, onClose }) {
  return (
    <>
      {/* Overlay */}
      <Overlay expanded={expanded} onClick={onClose} />

      {/* Sidebar */}
      <SidebarWrapper expanded={expanded}>
        <MenuNav>
          <MenuItem to="/dashboard" onClick={onClose}>
            <FaTachometerAlt /> Dashboard
          </MenuItem>

          <MenuItem to="/alunos" onClick={onClose}>
            <FaUserGraduate /> Alunos
          </MenuItem>

          <MenuItem to="/professores" onClick={onClose}>
            <FaChalkboardTeacher /> Professores
          </MenuItem>

          <MenuItem to="/turmas" onClick={onClose}>
            <FaUsers /> Turmas
          </MenuItem>

          <MenuItem to="/horarios" onClick={onClose}>
            <FaClock /> Horários
          </MenuItem>

          <MenuItem to="/inscricoes" onClick={onClose}>
            <FaClipboardList /> Inscrições
          </MenuItem>

          <MenuItem to="/mensalidades" onClick={onClose}>
            <FaFileInvoiceDollar /> Mensalidades
          </MenuItem>

          <MenuItem to="/caixa" onClick={onClose}>
            <FaCashRegister /> Caixa Diário
          </MenuItem>
        </MenuNav>
      </SidebarWrapper>
    </>
  );
}